import React from "react";
import SpecialistBanner from "../../assets/img/speacialist_banner.jpg";
import "../WhatDrivesUs.css";

export default function WhatDrivesUs() {
  return (
    <div className="wd-img top-img">
            <img src={SpecialistBanner} alt="Care Team" />
          </div>
  );
}

